"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTooltip = void 0;
const react_1 = __importDefault(require("react"));
const BaseTooltip = ({ payload, dataTestId }) => {
    if (!payload)
        return null;
    return (react_1.default.createElement("div", { className: "fds-container fds-borderless", "data-test-id": dataTestId }, payload.map((item) => {
        var _a;
        const label = (_a = item.payload.subtitle) !== null && _a !== void 0 ? _a : item.payload.value;
        return (react_1.default.createElement("div", { key: item.name },
            item.name,
            label ? `: ${label}` : ''));
    })));
};
exports.BaseTooltip = BaseTooltip;
